export const iconFontAwesomeGendersPersonHalfDress = (
	<i className="fa-solid fa-person-half-dress"></i>
);
